import type { SearchCriteria, PartialSearchCriteria } from '../../model/types';

export interface NightRangeParams {
  nightFrom?: number;
  nightTo?: number;
}

export function nightRange(criteria: SearchCriteria | PartialSearchCriteria): NightRangeParams {
  const range = criteria.nights;
  if (!range) {
    return {};
  }

  const params: NightRangeParams = {};
  if (range.from) {
    params.nightFrom = range.from;
  }
  if (range.to) {
    params.nightTo = range.to;
  }

  return params;
}
